import { apiService } from './api';

class UserService {
  async getAllUsers() {
    try {
      const response = await apiService.getUsers();
      return response.users || [];
    } catch (error) {
      console.error('Failed to fetch users:', error);
      throw error;
    }
  }

  async createUser(userData) {
    try {
      const response = await apiService.createUser(userData);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Failed to create user:', error);
      return { success: false, error: error.message };
    }
  }

  async updateUser(username, userData) {
    try {
      const response = await apiService.updateUser(username, userData);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Failed to update user:', error);
      return { success: false, error: error.message };
    }
  }

  async deleteUser(username) {
    try {
      const response = await apiService.deleteUser(username);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Failed to delete user:', error);
      return { success: false, error: error.message };
    }
  }

  // NEW: Get all available locations from database
  async getAvailableLocations() {
    try {
      const response = await apiService.getLocations();
      return response.locations || [];
    } catch (error) {
      console.error('Failed to fetch available locations:', error);
      return [];
    }
  }

  // Get user's assigned locations
  // FIXED: Changed from getUserLocationMappings to getUserLocations
  async getUserLocations(username) {
    try {
      const response = await apiService.getUserLocations(username);
      return response.locations || [];
    } catch (error) {
      console.error('Failed to fetch user locations:', error);
      return [];
    }
  }

  // Update user's location assignments
  // FIXED: Changed from updateUserLocationMappings to updateUserLocations
  async updateUserLocations(username, locations) {
    try {
      const response = await apiService.updateUserLocations(username, locations);
      return { success: true, message: response.message };
    } catch (error) {
      console.error('Failed to update user locations:', error);
      return { success: false, error: error.message };
    }
  }

  // Helper: Validate user data
  validateUserData(userData) {
    const errors = {};

    if (!userData.username || userData.username.trim() === '') {
      errors.username = 'Username is required';
    }

    if (!userData.email || !this.isValidEmail(userData.email)) {
      errors.email = 'Valid email is required';
    }

    if (userData.password && userData.password.length < 6) {
      errors.password = 'Password must be at least 6 characters';
    }

    if (!userData.query_cap || userData.query_cap < 0) {
      errors.query_cap = 'Query cap must be a positive number';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
    };
  }

  // Helper: Validate email
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Helper: Format user for display
  formatUserForDisplay(user) {
    return {
      ...user,
      isAdmin: user.is_admin === 'Yes',
      hasAllLocationAccess: user.location_access === 'ALL',
      displayName: user.email || user.username,
    };
  }
}

export const userService = new UserService();
export default userService;
